<template>
  <div>
    <user-actions-component></user-actions-component>
    <section class="bg-white py-5" aria-label="Favourite list">
      <b-container>
        <b-row>
          <b-col sm="12" md="12" lg="2">
            <back-button></back-button>
          </b-col>
          <b-col sm="12" md="12" lg="8">
            <!-- Title -->
            <h1 class="mb-3">{{ decodeURI(name) }}</h1>
            <div class="bg-light p-3 mb-4">
              <social-actions :service="shareData"></social-actions>
              <b-form inline>
                <b-input v-model="listTitle" class="mr-2 mb-2"></b-input>
                <b-button variant="primary" class="mr-2 mb-2" @click="editListTitle()"
                  >Edit title</b-button
                >
                <b-button v-b-modal.modal-delete variant="primary" class="mb-2"
                  >Delete list</b-button
                >

                <b-modal id="modal-delete" title="Delete" @ok="deleteList">
                  <p class="my-4">Are you sure you want to delete this list?</p>
                </b-modal>
              </b-form>
            </div>
            <!-- Lists -->
            <b-list-group v-if="favouriteList.length > 0">
              <b-list-group-item
                v-for="(item, item_id) in favouriteList"
                :key="item_id"
                class="d-flex d-flex align-items-center"
                ><router-link
                  :to="{
                    name: 'Service',
                    params: {
                      id: item.item_id,
                      name: encodeURIComponent(item.name),
                    },
                  }"
                  aria-label="View service infomation"
                  itemprop="url"
                >
                  {{ item.name }}
                </router-link>

                <b-button variant="primary" class="ml-auto" @click="doPopUp(item.item_id)"
                  >Remove</b-button
                >

                <b-modal
                  :id="item.item_id"
                  title="Are you sure?"
                  cancel-only
                  @ok="removeListItem(item.item_id)"
                >
                </b-modal>
              </b-list-group-item>
            </b-list-group>
            <div v-if="favouriteList.msg">{{ favouriteList.msg }}</div>
          </b-col>
        </b-row>
      </b-container>
    </section>
  </div>
</template>

<script>
import { APP_CONFIG } from '@/config/config'

import { FavouriteCall } from '@/common/api.service'
import BackButton from '@/components/elements/BackButton'
import UserActionsComponent from '../elements/UserActionsComponent.vue'
import SocialActions from '../elements/SocialActions.vue'
export default {
  name: 'FavouriteDisplaySingleList',
  components: {
    BackButton,
    UserActionsComponent,
    SocialActions,
  },
  props: {
    id: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      listTitle: '',
      favouriteList: [],
    }
  },
  computed: {
    shareData() {
      return {
        name: this.name,
        description: 'A list of services from ' + APP_CONFIG.siteUrl,
      }
    },
  },
  mounted() {
    this.getFavouriteList()
    this.listTitle = decodeURI(this.name)
  },
  methods: {
    async getFavouriteList() {
      const { data } = await FavouriteCall.post({
        req_id: 'get_user_favourite_list_by_id',
        list_id: this.id,
      })
      this.favouriteList = data
      return
    },
    async removeListItem(item_id) {
      await FavouriteCall.post({
        req_id: 'remove_favourite_item',
        list_id: this.id,
        item_id: item_id,
      })
      this.getFavouriteList()
    },
    async editListTitle() {
      await FavouriteCall.post({
        req_id: 'edit_user_favourite_list_title',
        list_id: this.id,
        title: this.listTitle,
      })
      //this.name = this.listTitle
    },
    async deleteList() {
      await FavouriteCall.post({
        req_id: 'delete_user_favourite_list_by_id',
        list_id: this.id,
      })
      return this.$router.push('/favourites')
    },
    doPopUp(id) {
      this.$bvModal.show(id)
    },
  },
}
</script>
